import { render, staticRenderFns } from "./PortalRegistrationMethod.vue?vue&type=template&id=63e0280e&scoped=true&"
import script from "./PortalRegistrationMethod.vue?vue&type=script&lang=js&"
export * from "./PortalRegistrationMethod.vue?vue&type=script&lang=js&"
import style0 from "./PortalRegistrationMethod.vue?vue&type=style&index=0&id=63e0280e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63e0280e",
  null
  
)

export default component.exports